import React from 'react';
import PropTypes from 'prop-types';

import { Button } from '@ontruck/orc';

const t = {
  assign_to_another: 'Assign to another driver',
  unassign: 'Confirm unassignment',
  release: 'Remove order from job',
  release_order: 'Release order (TMS will decide)',
  release_multiple: 'Release orders (TMS will decide)',
  cancel: 'Cancel',
};

const componentPropTypes = {
  action: PropTypes.func.isRequired,
};

const AssignAction = ({ action, ...props }) => (
  <Button fullWidth onClick={action} {...props}>
    {t.assign_to_another}
  </Button>
);

const UnassignAction = ({ action, ...props }) => (
  <Button fullWidth onClick={action} {...props}>
    {t.unassign}
  </Button>
);

const ReleaseAction = ({ action, showOrder = true, ...props }) => (
  <Button fullWidth onClick={action} {...props}>
    {showOrder ? t.release_order : t.release}
  </Button>
);

const ReleaseGroupageAction = ({ action, ...props }) => (
  <Button fullWidth onClick={action} {...props}>
    {t.release_multiple}
  </Button>
);

const CancelAction = ({ action }) => (
  <Button nude skin="secondary" fullWidth onClick={action}>
    {t.cancel}
  </Button>
);

AssignAction.propTypes = componentPropTypes;
UnassignAction.propTypes = componentPropTypes;
ReleaseAction.propTypes = { ...componentPropTypes, showOrder: PropTypes.bool };
ReleaseGroupageAction.propTypes = componentPropTypes;
CancelAction.propTypes = componentPropTypes;

export { AssignAction, UnassignAction, ReleaseAction, ReleaseGroupageAction, CancelAction };
